// src/pages/PaymentFailure.jsx
import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';

export default function PaymentFailure() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-red-100 dark:from-red-900/20 dark:to-red-800/10 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-2xl p-8 max-w-md w-full text-center">
        <XCircle className="w-16 h-16 text-red-500 mx-auto mb-6" />
        
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
          Payment Failed
        </h1>
        
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          Unfortunately, your payment could not be processed. Please try again or contact support.
        </p>

        <div className="space-y-3">
          <button
            onClick={() => window.history.back()}
            className="w-full btn-primary flex items-center justify-center gap-2"
          >
            <RefreshCw className="w-5 h-5" />
            Try Again
          </button>
          
          <Link
            to="/tours"
            className="w-full btn-secondary flex items-center justify-center gap-2"
          >
            <ArrowLeft className="w-5 h-5" />
            Back to Tours
          </Link>
        </div>
      </div>
    </div>
  );
}